import * as Yup from 'yup';

import capsuleValidation from 'src/app/utils/capsuleValidation';
import { FORM_VALIDATION_ERRORS } from 'src/consts';

const { doctorPhone } = capsuleValidation;

const initialValues = {
  doctorName: '',
  doctorPhone: '',
};

const schema = Yup.object().shape({
  doctorName: Yup.string().required(FORM_VALIDATION_ERRORS.doctorName),
  doctorPhone: doctorPhone().required(FORM_VALIDATION_ERRORS.doctorNumber),
});

export const validation = {
  schema,
  initialValues,
};
